import styled from 'styled-components'
import { defaultFontFamily } from '@sureco/design-system'

export const modalFontFamily = defaultFontFamily

export const ModalContent = styled.div`
  font-family: ${modalFontFamily};
  padding: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #000;

  /* Ensure all modal content (cards, form controls, etc.) uses the same font */
  & * {
    font-family: inherit;
  }
`

export const SectionCardWrapper = styled.div`
  margin-bottom: 20px;
`

export const SectionTitle = styled.h3`
  font-family: ${modalFontFamily};
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin: 0 0 12px 0;
  letter-spacing: -0.01em;
  line-height: 1.4;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 24px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldLabel = styled.div`
  font-family: ${modalFontFamily};
  font-size: 11px;
  font-weight: 600;
  color: #5a6b7d;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.3;
`

export const FieldValue = styled.div`
  font-family: ${modalFontFamily};
  font-size: 13px;
  font-weight: 400;
  color: #000;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.45;
`

export const CopyableValue = styled.span`
  font-family: ${modalFontFamily};
  cursor: pointer;
  color: #000;
  text-underline-offset: 2px;

  &:hover {
    text-decoration: underline;
  }
`

export const CopyIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5a6b7d;

  &:hover {
    color: #0958d9;
  }
`

export const cardStyle = {
  backgroundColor: '#f6f8fa',
  marginBottom: 0,
  border: '1px solid #dfe3e8',
} as const
